import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

const LazyCarrierActionsRoute = lazy(() => retry(() => import('app/pages/admin/CarrierActions')));

export const CarrierActions = (props: ComponentProps) => <LazyCarrierActionsRoute {...props} />;
